import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "../api/axios";
// import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import Select from "react-select";
 
const AddOperationModel = ({ show, handleClose }) => {
  // const [showCategory, setShowCategory] = useState(false);
  // const [showModel, setShowModel] = useState(false);
  // const [showEvents, setShowEvents] = useState(false);
  // const [showModal, setShowModal] = useState(false);
  // const [cabranesList, setCabranesList] = useState([]);
  const [backendSuccess, setBackendSuccess] = useState(null);
  const [backendErrors, setBackendErrors] = useState({});
 
   const [supplierName, setSupplierName] = useState([]);

   let season_id = localStorage.getItem("season_id");

  const [formData, setFormData] = useState({
    supplier:"",
    season_id:season_id,
    plate_number: "",
    driver_name: "",
    boxes: "",
    note:"",
    operation_type:'OUT'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setBackendErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };


  useEffect(() => {
      
        axios.post("/suppliers-trader-and-decay-customer/listing", {}, { headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      }
    ) .then((response) => {
      if (response.data.code === 200) {
        let suppliers = response.data.data.suppliers;
        let supplierslist = suppliers.map((cat, index) => ({
          label: cat.name,
          value: cat.name,
          key: `categories-${index}`,
        }));
        setSupplierName(supplierslist);
      } else {
        console.log("API response is not an array");
      }
    }).catch((error) => {
      console.log(error);
    });
 
  }, []);


  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("/crates-follow-up/add-crate", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          setTimeout(() => {
           window.location.href = "/crates-follow-up";
          }, 500);
        } else {
          setBackendErrors(response.data.error || {});
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  
  useEffect(() => {
      
        axios.post("/suppliers-trader-and-decay-customer/listing", {}, { headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      }
    ) .then((response) => {
      if (response.data.code === 200) {
        let suppliers = response.data.data.suppliers;
        let supplierslist = suppliers.map((cat, index) => ({
          label: cat.name,
          value: cat.name,
          key: `categories-${index}`,
        }));
        setSupplierName(supplierslist);
      } else {
        console.log("API response is not an array");
      }
    }).catch((error) => {
      console.log(error);
    });
 
  }, []);
  const handleSelectChangeCustomer = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, supplier: selectedOption.value }); 
  };
  return (
    <>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header>
          <h4 className="modal-title">Add Carete Follow Up</h4>
          <button
            type="button"
            className="close"
            data-bs-dismiss="modal"
            onClick={handleClose}
            aria-hidden="true"
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body><ToastContainer />
          <form onSubmit={handleSubmit}>
            {backendSuccess && (
              <div className="from-success mt-1">{backendSuccess}</div>
            )}

        <div className="form-group">
              <label>Select Supplier</label>
              <Select
                  options={supplierName}
                  name="supplier"
                  value={supplierName.find(option => option.value === formData.supplier) || null} // Ensure it selects the correct option
                  onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                  />
              {backendErrors.supplier && (
                <small className="form-error mt-1">{backendErrors.supplier}</small>
              )}
            </div>

            <div className="form-group">
              <label>Plate Name</label>
              <input
                className="form-control form-white"
                placeholder=""
                type="text"
                name="plate_number"
                value={formData.plate_number}
                onChange={handleChange}
              />
              {backendErrors.plate_number && (
                <small className="form-error mt-1">{backendErrors.plate_number}</small>
              )}
            </div>

            <div className="form-group">
              <label>Driver Name</label>
              <input
                className="form-control form-white"
                placeholder=""
                type="text"
                name="driver_name"
                value={formData.driver_name}
                onChange={handleChange}
              />
              {backendErrors.driver_name && (
                <small className="form-error mt-1">
                  {backendErrors.driver_name}
                </small>
              )}
            </div>

            <div className="form-group">
              <label>Boxes: </label>
              <input type='number'
                className="form-control form-white"
                placeholder=""
                name="boxes"
                value={formData.boxes}
                onChange={handleChange}
              />
              {backendErrors.boxes && (
                <small className="form-error mt-1">{backendErrors.boxes}</small>
              )}
            </div>
            <div className="form-group">
              <label>Operation Type: </label>
              <select name="operation_type"
                className="form-control form-white"
                value={formData.operation_type}
                onChange={handleChange}
              >
                <option value=''>Select</option>
                <option value='IN'>IN</option>
                <option value='OUT'>OUT</option>
                </select>
              {backendErrors.operation_type && (
                <small className="form-error mt-1">{backendErrors.operation_type}</small>
              )}
            </div>

            <div className="form-group">
              <label>Note: </label>
              <textarea type='number'
                className="form-control form-white"
                placeholder=""
                name="note"
                value={formData.note}
                onChange={handleChange}
              ></textarea>
              {backendErrors.note && (
                <small className="form-error mt-1">{backendErrors.note}</small>
              )}
            </div>
            <div className="submit-section">
              <button
                type="submit"
                className="btn btn-primary save-category submit-btn"
                data-bs-dismiss="modal"
              >
                SUBMIT
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

// Prop validation
AddOperationModel.propTypes = {
  show: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AddOperationModel;
